<template>
  <div class="container mt-10 text-center">
    <loading
      v-model:active="isLoading"
      :can-cancel="true"
      :on-cancel="onCancel"
      :is-full-page="fullPage"
    />
    <div class="back-btn">
      <a href="#" @click="$router.go(-1)">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </a>
    </div>
    <div class="head-title pb-0 px-4" v-if="info">
      <h2 class="text-capitalize">{{ info.data.name }}</h2>
    </div>
    <div class="details-section mt-3" v-if="info">
      <div class="row no-gutters">
        <div class="col-md-12">
          <div class="ship-info h-100">
            <div class="container text-left py-3 px-5">
              <div class="row">
              <div class="col-lg-3 col-sm-12 col-md-5 col-xs-12 mt-4">
                <div class="card pull-left">
                  <vue-load-image>
                    <template v-slot:image>
                      <img
                        class="card-img-top px-3 pt-3 pb-0"
                        :src="getImgUrl(info.data.img)"
                        alt=""
                      />
                    </template>
                    <template v-slot:preloader>
                      <img
                        class="card-img-top px-3 pt-3 pb-0"
                        src="/lostsailor/images/loader.gif"
                      />
                    </template>
                    <template v-slot:error>Image load fails</template>
                  </vue-load-image>
                </div>
                </div>
                <div class="col-lg-9 col-sm-12 col-md-7 col-xs-12">
                  <div class="small-text">
                    <h6 class="grey-color mb-0 pb-0">Name</h6>
                    <h6 class="id text-white font-weight-bold">
                      {{ info.data.name }}
                    </h6>
                  </div>
                  <div class="small-text">
                    <h6 class="grey-color mb-0 pb-0">Description</h6>
                    <h6 class="text-white">
                      {{ info.data.description }}
                    </h6>
                  </div>
                <div class="col-md-6">
                  <!-- <div class="small-text">
                    <h6 class="grey-color">NFT Name</h6>
                    <h2>{{ info.data.name }}</h2>
                  </div> -->
                  <div class="small-text">
                    <h6 class="grey-color mb-0 pb-0">Rarity</h6>
                    <h5 class="text-white font-weight-bold">
                      <a href="#" class="light-red">{{ info.data.rarity }}</a>
                    </h5>
                  </div>
                  <div class="small-text">
                    <h6 class="grey-color mb-0 pb-0">ID</h6>
                    <h5 class="id text-white font-weight-bold">
                      #{{ info.asset_id }}
                    </h5>
                  </div>
                  <!-- <div class="small-text">
                    <h6 class="grey-color mb-0 pb-0">owner</h6>
                    <h5 class="owner-name font-weight-bold">
                      <a href="#" class="light-red">{{ info.owner }}</a>
                    </h5>
                  </div> -->
                </div>
                <div class="col-md-6">
                  <div class="small-text">
                    <!-- <h6 class="grey-color">Collocation name</h6>
                    <h2>{{ info.collection.collection_name }}</h2> -->
                  </div>
                  <div class="small-text">
                    <h6 class="grey-color mb-0 pb-0">Schema name</h6>
                    <h5 class="font-weight-bold light-red">
                      {{ info.schema.schema_name }}
                    </h5>
                  </div>
                  <div class="small-text">
                    <h6 class="grey-color mb-0 pb-0">Template ID</h6>
                    <h5 class="owner-name font-weight-bold light-red">
                      #{{ info.template.template_id }}
                    </h5>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                  <div class="col-md-4" v-if="info.data.attackpower">
                  <div class="small-text">
                    <h4 class="grey-color mb-0 pb-0">Attake Power</h4>
                    <h1 class="text-white">
                      <span class="light-red">{{info.data.attackpower || 0}}</span>
                    </h1>
                  </div>
                  </div>
                  <div class="col-md-4" v-if="info.data.experience">
                  <div class="small-text">
                    <h4 class="grey-color mb-0 pb-0">Experience</h4>
                    <h1 class="text-white">
                      <span class="light-red">{{info.data.experience || 0}}</span>
                    </h1>
                  </div>
                  </div>
                  <div class="col-md-4" v-if="info.data.leadership">
                  <div class="small-text">
                    <h4 class="grey-color mb-0 pb-0">Leadership</h4>
                    <h1 class="text-white">
                      <span class="light-red">{{info.data.leadership || 0}}</span>
                    </h1>
                  </div>
                  </div>
                  <div class="col-md-4" v-if="info.data.strategy">
                  <div class="small-text">
                    <h4 class="grey-color mb-0 pb-0">Strategy</h4>
                    <h1 class="text-white">
                      <span class="light-red">{{info.data.strategy || 0}}</span>
                    </h1>
                  </div>
                  </div>
                  <div class="col-md-4" v-if="info.data.tradepower">
                  <div class="small-text">
                    <h4 class="grey-color mb-0 pb-0">Trade Power</h4>
                    <h1 class="text-white">
                      <span class="light-red">{{info.data.tradepower || 0}}</span>
                    </h1>
                  </div>
                  </div>
                  <div class="col-md-4" v-if="info.data.speed">
                  <div class="small-text">
                    <h4 class="grey-color mb-0 pb-0">Speed</h4>
                    <h1 class="text-white">
                      <span class="light-red">{{info.data.speed || 0}}</span>
                    </h1>
                  </div>
                  </div>
                  <div class="col-md-4" v-if="info.data.use">
                  <div class="small-text">
                    <h4 class="grey-color mb-0 pb-0">Use</h4>
                    <h1 class="text-white">
                      <span class="light-red">{{info.data.use || 0}}</span>
                    </h1>
                  </div>
                  </div>
                  <div class="col-md-4" v-if="info.data.extrapower">
                  <div class="small-text">
                    <h4 class="grey-color mb-0 pb-0">Extra Power</h4>
                    <h1 class="id text-white font-weight-bold">
                      {{info.data.extrapower || 0}}
                    </h1>
                  </div>
                  </div>
                  <div class="col-md-4" v-if="info.data.extraspeed">
                  <div class="small-text">
                    <h4 class="grey-color mb-0 pb-0">Extra Speed</h4>
                    <h1 class="id text-white font-weight-bold">
                      {{info.data.extraspeed || 0}}
                    </h1>
                  </div>
                  </div>
                </div>
                </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ApiService from "../services";
import Loading from "vue-loading-overlay";
import VueLoadImage from "vue-load-image";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "Details",
  components: {
    Loading,
    "vue-load-image": VueLoadImage,
  },
  data() {
    return {
      userFilter: null,
      info: null,
      isLoading: false,
      fullPage: true,
      status: false,
      assetId: "",
      row: {},
      assetIds: [],
      showModal: false,
      showStackModal: false,
      error: false,
      activeMenuSearch: false,
      activeMenu: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    calculatePrice(price) {
      return price;
      // return ApiService.calculatePrice(price[0]);
    },
    getImgUrl(hash) {
      return ApiService.getImgUrl(hash);
    },
    init() {
      this.isLoading = true;
      ApiService.getAssetById(this.$route.params.id, (response) => {
        let res = response["data"];
        if (res["success"]) {
          this.info = res["data"];
        } else {
          this.info = [];
        }
        this.loading = false;
        this.isLoading = false;
      });
    },
  },
};
</script>

<style>
.container .back-btn {
  float: right;
  margin-top: -10px;
  margin-left: 10px;
}
</style>